import axios, { AxiosRequestConfig } from 'axios'
import { setupAxios } from './AuthHelpers'
import {AuthModel, UserModel} from './_models'

const API_URL = "https://shifatr.org/api/auth"
export const GET_CURRENTUSER_URL = `${API_URL}/getcurrentuser`
export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/verifytoken`
export const LOGIN_URL = `${API_URL}/login`
export const REGISTER_URL = `${API_URL}/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/forgot_password`

// Server should return AuthModel
export function login(email: string, password: string) {
  return axios.post<AuthModel>(LOGIN_URL, {
    email,
    password,
  })
}


// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export async function getUserByToken() {
  const config : AxiosRequestConfig | any =  await setupAxios(axios)
  return axios.get<UserModel>(GET_CURRENTUSER_URL, {})
  
}

export async function verifyToken() {
  return axios.get<AuthModel>(GET_USER_BY_ACCESSTOKEN_URL,{})
}
